import { call, put, takeLeading } from 'redux-saga/effects';

import managerOperationApi from 'api/managerOperation';
import { apiErrorHandler, convertIsoDateToString } from 'utils';

import {
  actionGetActionHistoriesSuccess,
  actionGetActionHistoriesFailed,
  actionExportActionHistoriesSuccess,
  actionExportActionHistoriesFailed,
} from './actions';
import {
  GET_ACTION_HISTORIES,
  EXPORT_ACTION_HISTORIES,
} from './actionTypes';

const MODULE_LABELS = {
  PLACE: 'Chỗ nghỉ',
  INTRANET_ADMINISTRATOR: 'Quản lý tài khoản người dùng',
  EXTRANET_ADMINISTRATOR: 'Tài khoản chỗ nghỉ',
  EXT: 'Tài khoản chỗ nghỉ',
  USER: 'Khách hàng',
  BOOKING: 'Đặt phòng',
  BOOKING_REVIEW: 'Đánh giá đặt phòng',
  REVENUE: 'Doanh thu',
  RANKING: 'Xếp hạng',
  FINANCE: 'Tài chính',
};

const ACTION_TYPE_LABELS = {
  CREATE: 'Thêm',
  UPDATE: 'Sửa',
  DELETE: 'Xoá',
};

const mapActionHistoryToOperation = (item) => ({
  id: item._id,
  operatorName: item.intranetAdministrator?.fullName || '—',
  category: MODULE_LABELS[item.module] || item.module || '—',
  action: ACTION_TYPE_LABELS[item.actionType] || item.actionType || '—',
  description: item.description || '',
  changedAt: convertIsoDateToString(item.createdAt, 'DD/MM/YYYY HH:mm'),
});

function* getActionHistories({ payload }) {
  try {
    const response = yield call(managerOperationApi.getActionHistories, payload);
    const rawData = response.payload?.data || response.payload || [];
    const total = response.payload?.total ?? response.total ?? rawData.length;

    const data = Array.isArray(rawData)
      ? rawData.map(mapActionHistoryToOperation)
      : [];

    yield put(actionGetActionHistoriesSuccess({ data, total }));
  } catch (error) {
    apiErrorHandler(error);

    yield put(actionGetActionHistoriesFailed());
  }
}

function* exportActionHistories({ payload }) {
  try {
    const response = yield call(managerOperationApi.exportActionHistories, payload);

    window.open(response.payload.downloadUrl, '_blank');

    yield put(actionExportActionHistoriesSuccess());
  } catch (error) {
    apiErrorHandler(error);

    yield put(actionExportActionHistoriesFailed());
  }
}

export default function* managerOperationSaga() {
  yield takeLeading(GET_ACTION_HISTORIES, getActionHistories);
  yield takeLeading(EXPORT_ACTION_HISTORIES, exportActionHistories);
}
